/** Findings associated with any user (finding has a uid / view user_id is populated). */
export const USER_ASSOCIATED_ANY = 'any';

export const USER_ASSOCIATION_FILTER_KEY = 'user_associated';

export const USER_ID_FILTER_KEY = 'user_id';

/** Split modal/card default filters into AG set filters vs user association param. */
export function extractUserAssociationFromDefaultFilter(defaultFilter: Record<string, string[]>): {
  setFilters: Record<string, string[]>;
  userAssociated?: string;
} {
  const setFilters: Record<string, string[]> = {};
  let userAssociated: string | undefined;

  Object.entries(defaultFilter).forEach(([key, values]) => {
    if (key === USER_ASSOCIATION_FILTER_KEY) {
      const first = Array.isArray(values) ? values[0] : undefined;
      if (typeof first === 'string' && first.length > 0) {
        userAssociated = first;
      }
      return;
    }
    if (values !== undefined && values !== null) {
      setFilters[key] = values;
    }
  });

  return { setFilters, userAssociated };
}

type UserIdHasUserFilter = { [K in typeof USER_ID_FILTER_KEY]: { $neq: null } };

export function userAssociationFilterFromParam(value: unknown): UserIdHasUserFilter | undefined {
  if (value === true || value === USER_ASSOCIATED_ANY || value === 'true') {
    return { [USER_ID_FILTER_KEY]: { $neq: null } };
  }
  return undefined;
}

function hasSpecificUserIdFilter(userId: unknown): boolean {
  if (typeof userId === 'string' && userId.length > 0) {
    return true;
  }
  if (userId && typeof userId === 'object' && '$in' in userId) {
    const inValues = (userId as { $in?: unknown }).$in;
    return Array.isArray(inValues) && inValues.some((entry) => typeof entry === 'string' && entry.length > 0);
  }
  return false;
}

/**
 * Resolves optional `user_associated=any` into a `user_id IS NOT NULL` filter for findings insights.
 * Specific `user_id` filters take precedence.
 */
export function normalizeFindingsFilterCriteria(
  criteria: Record<string, unknown> | undefined
): Record<string, unknown> {
  if (!criteria || typeof criteria !== 'object') {
    return {};
  }

  const { [USER_ASSOCIATION_FILTER_KEY]: userAssociated, ...rest } = criteria;
  const associationFilter = userAssociationFilterFromParam(userAssociated);

  if (!associationFilter) {
    return rest;
  }

  if (hasSpecificUserIdFilter(rest[USER_ID_FILTER_KEY])) {
    return rest;
  }

  return { ...rest, ...associationFilter };
}
